// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import AsyncSelectController from "./async_select_controller"
application.register("async-select", AsyncSelectController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import DonationFormController from "./donation_form_controller"
application.register("donation-form", DonationFormController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import PaginatedListController from "./paginated_list_controller"
application.register("paginated-list", PaginatedListController)

import SharePanelController from "./share_panel_controller"
application.register("share-panel", SharePanelController)

import SidePanelController from "./side_panel_controller"
application.register("side-panel", SidePanelController)

import SmoothScrollController from "./smooth_scroll_controller"
application.register("smooth-scroll", SmoothScrollController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)
